import {
  TransformWrapper,
  TransformComponent,
  type ReactZoomPanPinchRef,
} from 'react-zoom-pan-pinch';
import React, { useEffect, useRef, useState } from 'react';

import styles from './index.module.scss';

interface CarouselProps {
  images: string[];
  slideNumber?: number;
}

const Carousel = ({ images, slideNumber }: CarouselProps) => {
  const transformWrapperRef = useRef<ReactZoomPanPinchRef>(null);

  const [index, setIndex] = useState(slideNumber || 0);

  const goNext = () => {
    transformWrapperRef.current?.resetTransform();
    setIndex((prevIndex) => prevIndex + 1);
  };

  const goPrev = () => {
    transformWrapperRef.current?.resetTransform();
    setIndex((prevIndex) => prevIndex - 1);
  };

  useEffect(() => {
    if (slideNumber) {
      transformWrapperRef.current?.resetTransform();
      setIndex(slideNumber);
    }
  }, [slideNumber]);

  return (
    <div className={styles.container}>
      <div className={styles.galleryContainer}>
        <button
          onClick={goPrev}
          className={index === 0 ? styles.hiddenButton : styles.prevArrow}
        >
          <div className={styles.arrow} />
        </button>
        <TransformWrapper
          initialScale={1}
          initialPositionX={0}
          initialPositionY={0}
          ref={transformWrapperRef}
        >
          <TransformComponent>
            <img src={images[index]} className={styles.image} />
          </TransformComponent>
        </TransformWrapper>
        <button
          onClick={goNext}
          className={
            index === images.length - 1 ? styles.hiddenButton : styles.nextArrow
          }
        >
          <div className={styles.arrow} />
        </button>
      </div>
    </div>
  );
};

export default Carousel;
